import React from 'react';
import PropTypes from 'prop-types';
import { Container, Label, Value } from './styles';

export default function Fact({ label, value }) {
  return (
    <Container>
      <Label>{label}</Label>
      <Value>{value}</Value>
    </Container>
  );
}

Fact.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
